import { constructQueryParams } from '@/utils/utils';
import api from '../services/axios.service';

/**
 * Fetches tags data.
 * @param {Object} params - The parameters to filter the tags data.
 * @param {string} params.tag_type - The types of the tags. It is optional. If sent, it should be an array.
 * @param {string[]} params.tag_ids - The IDs of the tags. It is optional. If sent, it should be an array.
 * @returns {Promise<Object>} The tags data.
 */
export async function fetchTags(
    { tag_type = null, tag_ids = null } = {
        tag_type: null,
        tag_ids: null
    }
) {
    const queryParams = constructQueryParams({ tag_type, tag_ids });

    return api.get(queryParams ? `tags?${queryParams}` : 'tags');
}

export async function addTag(tag) {
    return api.post(`tags`, tag);
}

export async function updateTag(tag) {
    if (!tag.id) {
        throw new Error('Tag ID is required to update a tag');
    }

    return api.put(`tags/${tag.id}`, tag);
}

export async function deleteTag(tagId) {
    return api.delete(`tags/${tagId}`);
}
